import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "../core/Error.js";
import r from "../core/has.js";
import { isSome as o, isNone as s } from "../core/maybe.js";
import { whenOrAbort as i } from "../core/promiseUtils.js";
import { property as u } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as n } from "../core/accessorSupport/decorators/subclass.js";
import { DataLayerSource as a } from "../layers/support/source/DataLayerSource.js";
import { executeAttachmentQuery as c } from "../rest/query/executeAttachmentQuery.js";
import { executeForCount as p } from "../rest/query/executeForCount.js";
import { executeForExtent as m } from "../rest/query/executeForExtent.js";
import { executeForIds as f } from "../rest/query/executeForIds.js";
import { executeRawQueryJSON as l } from "../rest/query/executeQueryJSON.js";
import { executeRawQueryPBF as h } from "../rest/query/executeQueryPBF.js";
import { executeRelationshipQuery as d, executeRelationshipQueryForCount as y } from "../rest/query/executeRelationshipQuery.js";
import { executeTopFeaturesQuery as F } from "../rest/query/executeTopFeaturesQuery.js";
import { executeForTopIds as S } from "../rest/query/executeForTopIds.js";
import { executeForTopExtents as j } from "../rest/query/executeForTopExtents.js";
import { executeForTopCount as D } from "../rest/query/executeForTopCount.js";
import x from "../rest/support/FeatureSet.js";
import O from "../rest/support/Query.js";
import b from "../rest/support/RelationshipQuery.js";
import q from "./Task.js";

var g = /*#__PURE__*/function (_q) {
  _inherits(g, _q);

  var _super = _createSuper(g);

  function g(e) {
    var _this;

    _classCallCheck(this, g);

    _this = _super.call(this, e), _this.dynamicDataSource = null, _this.fieldsIndex = null, _this.format = "json", _this.gdbVersion = null, _this.infoFor3D = null, _this.sourceSpatialReference = null;
    return _this;
  }

  _createClass(g, [{
    key: "execute",
    value: function execute(e, t) {
      var _this2 = this;

      return this.executeJSON(e, t).then(function (r) {
        return _this2.featureSetFromJSON(e, r, t);
      });
    }
  }, {
    key: "executeJSON",
    value: function () {
      var _executeJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
        var o, s, i, u, n, a, c;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                s = _objectSpread(_objectSpread({}, this.requestOptions), t), i = this._normalizeQuery(e), u = null != (null == (o = e.outStatistics) ? void 0 : o[0]), n = r("featurelayer-pbf-statistics"), a = !u || n;

                if (!("pbf" === this.format && a)) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return h(this.url, i, s);

              case 5:
                c = _context.sent;
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);

                if (!("query:parsing-pbf" !== _context.t0.name)) {
                  _context.next = 12;
                  break;
                }

                throw _context.t0;

              case 12:
                this.format = "json";

              case 13:
                _context.t1 = "json" !== this.format && a;

                if (_context.t1) {
                  _context.next = 18;
                  break;
                }

                _context.next = 17;
                return l(this.url, i, s);

              case 17:
                c = _context.sent;

              case 18:
                this._normalizeFields(c.fields);

                return _context.abrupt("return", c);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function executeJSON(_x, _x2) {
        return _executeJSON.apply(this, arguments);
      }

      return executeJSON;
    }()
  }, {
    key: "featureSetFromJSON",
    value: function () {
      var _featureSetFromJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t, r) {
        var _yield$i, s;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._queryIs3DObjectFormat(e) && o(this.infoFor3D) && t.features && t.features.length) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", x.fromJSON(t));

              case 2:
                _context2.next = 4;
                return i(import("../rest/support/meshFeatureSet.js"), r);

              case 4:
                _yield$i = _context2.sent;
                s = _yield$i.meshFeatureSetFromJSON;
                return _context2.abrupt("return", s(e, this.infoFor3D, t));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function featureSetFromJSON(_x3, _x4, _x5) {
        return _featureSetFromJSON.apply(this, arguments);
      }

      return featureSetFromJSON;
    }()
  }, {
    key: "executeForCount",
    value: function executeForCount(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t),
          o = this._normalizeQuery(e);

      return p(this.url, o, r);
    }
  }, {
    key: "executeForExtent",
    value: function executeForExtent(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t),
          o = this._normalizeQuery(e);

      return m(this.url, o, r);
    }
  }, {
    key: "executeForIds",
    value: function executeForIds(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t),
          o = this._normalizeQuery(e);

      return f(this.url, o, r);
    }
  }, {
    key: "executeRelationshipQuery",
    value: function executeRelationshipQuery(e, t) {
      e = b.from(e);

      var r = _objectSpread(_objectSpread({}, this.requestOptions), t);

      return (this.gdbVersion || this.dynamicDataSource) && ((e = e.clone()).gdbVersion = e.gdbVersion || this.gdbVersion, e.dynamicDataSource = e.dynamicDataSource || this.dynamicDataSource), d(this.url, e, r);
    }
  }, {
    key: "executeRelationshipQueryForCount",
    value: function executeRelationshipQueryForCount(e, t) {
      e = b.from(e);

      var r = _objectSpread(_objectSpread({}, this.requestOptions), t);

      return (this.gdbVersion || this.dynamicDataSource) && ((e = e.clone()).gdbVersion = e.gdbVersion || this.gdbVersion, e.dynamicDataSource = e.dynamicDataSource || this.dynamicDataSource), y(this.url, e, r);
    }
  }, {
    key: "executeAttachmentQuery",
    value: function executeAttachmentQuery(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t);

      return c(this.url, e, r);
    }
  }, {
    key: "executeTopFeaturesQuery",
    value: function executeTopFeaturesQuery(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t);

      return F(this.parsedUrl, e, this.sourceSpatialReference, r);
    }
  }, {
    key: "executeForTopIds",
    value: function executeForTopIds(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t);

      return S(this.parsedUrl, e, r);
    }
  }, {
    key: "executeForTopExtents",
    value: function executeForTopExtents(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t);

      return j(this.parsedUrl, e, r);
    }
  }, {
    key: "executeForTopCount",
    value: function executeForTopCount(e, t) {
      var r = _objectSpread(_objectSpread({}, this.requestOptions), t);

      return D(this.parsedUrl, e, r);
    }
  }, {
    key: "_normalizeQuery",
    value: function _normalizeQuery(e) {
      var r = O.from(e);

      if (r.sourceSpatialReference = r.sourceSpatialReference || this.sourceSpatialReference, (this.gdbVersion || this.dynamicDataSource) && (r = r === e ? r.clone() : r, r.gdbVersion = e.gdbVersion || this.gdbVersion, r.dynamicDataSource = e.dynamicDataSource ? a.from(e.dynamicDataSource) : this.dynamicDataSource), o(this.infoFor3D) && this._queryIs3DObjectFormat(e)) {
        r = r === e ? r.clone() : r, r.formatOf3DObjects = null;

        var _iterator = _createForOfIteratorHelper(this.infoFor3D.queryFormats),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;

            if ("3D_glb" === _e.id) {
              r.formatOf3DObjects = _e.id;
              break;
            }

            "3D_gltf" !== _e.id || r.formatOf3DObjects || (r.formatOf3DObjects = _e.id);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (!r.formatOf3DObjects) throw new t("query:unsupported-3d-query-formats", "Could not find any supported 3D object query format. Only supported formats are 3D_glb and 3D_gltf");

        if (s(r.outFields) || !r.outFields.includes("*")) {
          r = r === e ? r.clone() : r, s(r.outFields) && (r.outFields = []);
          var _this$infoFor3D$trans = this.infoFor3D.transformFieldRoles,
              _t = _this$infoFor3D$trans.originX,
              _o = _this$infoFor3D$trans.originY,
              _i = _this$infoFor3D$trans.originZ,
              _u = _this$infoFor3D$trans.translationX,
              _n = _this$infoFor3D$trans.translationY,
              _a = _this$infoFor3D$trans.translationZ,
              c = _this$infoFor3D$trans.scaleX,
              _p = _this$infoFor3D$trans.scaleY,
              _m = _this$infoFor3D$trans.scaleZ,
              _f = _this$infoFor3D$trans.rotationX,
              _l = _this$infoFor3D$trans.rotationY,
              _h = _this$infoFor3D$trans.rotationZ,
              _d = _this$infoFor3D$trans.rotationDeg;
          r.outFields.push(_t, _o, _i, _u, _n, _a, c, _p, _m, _f, _l, _h, _d);
        }
      }

      return r;
    }
  }, {
    key: "_normalizeFields",
    value: function _normalizeFields(e) {
      if (o(this.fieldsIndex) && o(e)) {
        var _iterator2 = _createForOfIteratorHelper(e),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _t2 = _step2.value;

            var _e2 = this.fieldsIndex.get(_t2.name);

            _e2 && Object.assign(_t2, _e2.toJSON());
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "_queryIs3DObjectFormat",
    value: function _queryIs3DObjectFormat(e) {
      return o(this.infoFor3D) && e.returnGeometry && "xyFootprint" !== e.multipatchOption && !e.outStatistics;
    }
  }]);

  return g;
}(q);

e([u({
  type: a
})], g.prototype, "dynamicDataSource", void 0), e([u()], g.prototype, "fieldsIndex", void 0), e([u()], g.prototype, "format", void 0), e([u()], g.prototype, "gdbVersion", void 0), e([u()], g.prototype, "infoFor3D", void 0), e([u()], g.prototype, "sourceSpatialReference", void 0), g = e([n("esri.tasks.QueryTask")], g);
var Q = g;
export { Q as default };